
import { apiFetch } from "./api";

export function getGlobalDashboardIframe(id) {
  return apiFetch(`/global-dashboard/${id}/iframe`, {
    method: "GET",
  });
}

export function postGlobalDashboardIframe(id, globalDashboard, iframe) {
  return apiFetch(`/global-dashboard/${id}/iframe`, {
    method: "POST",
    body: JSON.stringify({globalDashboard, iframe})
  });
}
